import { makeStyles, IconButton, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';
import WarningIcon from '@material-ui/icons/Warning';
import ReplayIcon from '@material-ui/icons/Replay';

const useStyles = makeStyles((theme) => ({
  divider: {
    margin: theme.spacing(0.5, 0),
  },
}));

const LoadingErrorWidget = ({ onReload }) => {
  const classes = useStyles();
  const { en: { errors } } = useSelector((state) => state.i18n);
  return <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
    maxWidth: 400,
    gap: 2,
  }}>
    <WarningIcon style={{
      color: 'rgb(221, 77, 77)',
      paddingRight: 10,
      width: 35,
    }} />
    <Typography style={{
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      overflowWrap: 'break-word',
      fontSize: '.8rem',
    }}>
      {errors.loadingError}
    </Typography>

    <IconButton
      aria-label='update'
      className={classes.iconButton}
      onClick={onReload}
      classes={{ label: classes.label }}
    >
      <ReplayIcon />
    </IconButton>
  </div>;
};

export default LoadingErrorWidget;
